/* eslint-disable no-unused-vars */
import * as React from 'react';
import { TextField  } from '@mui/material';
import PropTypes from 'prop-types';
/* eslint-disable no-useless-escape */
export default class FTextField extends React.Component{

    constructor(props){
        super(props);
        this.state={
            error:'',
            helperText:'',
            errorCustom:false
        }
        this.inputRef = React.createRef();
    }

    componentDidMount(){ 
        if(this.props.error === true){
            this.setState({error: this.props.error, helperText: this.props.helperText})
        }
    }


  static getDerivedStateFromProps(nextProps, prevState) {
    if(nextProps.value !== prevState.value){
        //////console.log("VALUE", nextProps.value, prevState.value)
        return {value: nextProps.value}
    }
    // console.log("ERROR",nextProps, nextProps.error, prevState.error)
    if (nextProps.error !== prevState.error && !prevState.errorCustom ) {
        
      return { error: nextProps.error, helperText: nextProps.helperText };
    }
    return null;
  }

    render(){
        return <>
        {this.props.autoFocus === true &&<TextField autoFocus={this.props.autoFocus}
            defaultValue='aaa'
            ref={this.inputRef}
            label={this.props.label}
            name ={this.props.name}
            id={this.props.name}
            error={this.state.error}
            helperText={this.state.helperText} 
            type={this.props.type}
            value={this.props.value||''}
            disabled={this.props.disabled}
            required={this.props.required}
            fullWidth={this.props.fullWidth}
            InputProps={{
                autoComplete: 'off',
                ...this.props.InputProps
            }}
            onChange={(e)=>{
                //console.log(this.props.format); 
                
                if(e.target.value.length >= (Number(this.props.maxLength))){
                    e.target.value = e.target.value.substring(0, this.props.maxLength)
                }
                this.props.onChange(e)
            }}
            style={this.props.style}
            placeholder={this.props.label}
            tabindex={this.props.tabindex}
            onKeyDown={(e)=>{ 
                ////console.log(e)
                if(this.props.maxLength !== undefined && Number(this.props.maxLength) > 0 && this.props.format === 'text'){
                    if(e.keyCode !== 8 && e.keyCode !== 9 && e.keyCode !== 37 && e.keyCode !== 39 && e.keyCode !== 46 && e.target.value.length >= (Number(this.props.maxLength)+1) && e.key !== 'Ctrl' && e.key !== 'Shift'){
                        e.preventDefault();
                    }
                }
                
                if((this.props.format === 'number' ) && e.key!=='Tab' && e.keyCode !== 8 && e.keyCode !== 46){
                    const pattern = /^[0-9]$/;  
                    // //console.log("NUMBER FORMAT")
                    // //console.log(e)
                    if(!pattern.test(e.key)){
                        e.preventDefault();
                    } 
                }
                else if((this.props.format === 'numberdecimal' || this.props.format === 'currency') && e.target.value.toString().indexOf('.') === -1 && e.keyCode !== 8 && e.keyCode !== 9 && e.keyCode !== 46 ){
                    const pattern = /^[0-9.]$/; 
                    //console.log(e)
                    //console.log(pattern.test(e.key))
                    if(!pattern.test(e.key) && e.keyCode !== 9 && e.keyCode !== 37 && e.keyCode !== 39){
                        e.preventDefault();
                    }
                }
                else if((this.props.format === 'numberdecimal' || this.props.format === 'currency') && e.target.value.toString().indexOf('.') !== -1 && e.keyCode !== 8 && e.keyCode !== 9 && e.keyCode !== 46 ){
                    // const pattern =; 
                    //////console.log(e)
                    if(! /^[0-9]$/.test(e.key) && e.keyCode !== 9 && e.keyCode !== 37 && e.keyCode !== 39){
                        e.preventDefault();
                    }
                }

                else if(this.props.format === 'percentage' && e.target.value.toString().indexOf('.') === -1 && e.keyCode !== 8 && e.keyCode !== 9 && e.keyCode !== 46 ){
                    const pattern = /^[0-9.]$/; 
                    //////console.log(e)
                    if(!pattern.test(e.key) && e.keyCode !== 9 && e.keyCode !== 37 && e.keyCode !== 39){
                        e.preventDefault();
                    }
                    let temp = (e.target.value+e.key).toString().split(".") 
                    let chkval = temp.length > 1 ? temp[1].length  : 2
                    if(Number((e.target.value+e.key)) === 100 && e.key === '.'){
                        e.preventDefault()
                    }
                    if(Number((e.target.value+e.key)) > 100 || chkval > 2){
                        e.preventDefault()
                    }
                }
                else if(this.props.format === 'percentage' && e.target.value.toString().indexOf('.') !== -1 && e.keyCode !== 8 && e.keyCode !== 9 && e.keyCode !== 46 ){
                    // const pattern =; 
                    //////console.log(e)
                    if(! /^[0-9]$/.test(e.key) && e.keyCode !== 9 && e.keyCode !== 37 && e.keyCode !== 39){
                        e.preventDefault();
                    }
                    let temp = (e.target.value+e.key).toString().split(".") 
                    let chkval = temp.length > 1 ? temp[1].length  : 2
                    if(Number((e.target.value+e.key)) === 100 && e.key === '.'){
                        e.preventDefault()
                    }
                    if(Number((e.target.value+e.key)) > 100 || chkval > 2){
                        e.preventDefault()
                    }
                }


                else if(this.props.format==='text' || this.props.format==='string'){
                    var k ;
                    document.all ? k = e.keyCode : k = e.which;
                    ////console.log(k)
                    // var iChars = "!@#$%^&*()+=-[]\\\';,./{}|\":<>?";
                    // if(((k > 64 && k < 91) || (k > 96 && k < 123)|| k===39 || k===37 || k ===9  || k === 8 || k === 32)){
                    //     ////console.log("IF")
                    //     if(iChars.indexOf(e.))
                    // }
                    // else{
                    //     ////console.log("ELSE")
                    //     e.preventDefault();
                    // }

                    let key = e.key;
                    let keyCharCode = key.charCodeAt(0);
//console.log(keyCharCode)
                    const pattern = /^[a-zA-Z0-9]*$/ 
                    // 0-9
                    if(keyCharCode >= 48 && keyCharCode <= 57) {
                        return key;
                    }
                    // A-Z
                    else if(keyCharCode >= 65 && keyCharCode <= 90) {
                        return key;
                    }
                    // a-z
                    else if(keyCharCode >= 97 && keyCharCode <= 122) {
                        return key;
                    }
                    // space , - 
                    else if(keyCharCode === 32 || keyCharCode === 44 ||keyCharCode === 45) {
                        return key;
                    }
                    else if(pattern.test(e.key)){//
                        e.preventDefault();
                    }
                    else{
                        ////console.log("ELSE")
                        e.preventDefault();
                    }
                } 
                else if(this.props.format === 'email'){
                    var m;
                     document.all ? m = e.keyCode : m = e.which;  
                     const pattern = /^[a-zA-Z0-9_@.-]*$/
                     if(pattern.test(e.key)){//((m > 64 && m < 91) || (m > 96 && m < 123) || m===39 || m===37 || m===9 || m === 8 || m === 32 || m === 50 || m === 190)){
                        ////console.log("IF")

    // Check if the current input value matches the email-like pattern

                        // var tmp = this.props.value.split(".")
                        // if(tmp[1].length >= 3 && e.keyCode !== 8 && e.keyCode !== 9 && e.keyCode !== 46){
                        //     e.preventDefault()
                        // }
                        // var tmp = this.props.value.split(".")
                        // if(tmp[1].length >= 3 && e.keyCode !== 8 && e.keyCode !== 9 && e.keyCode !== 46){
                        //     e.preventDefault()
                        // }
                    }
                    else{
                        ////console.log("ELSE")
                        e.preventDefault();
                    }
                } 
            }}
            onBlur={()=>{
                this.setState({error:false, helperText:'',errorCustom:false}) 
                if(this.props.format === 'email'){
                    var validRegex =  /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/; ///^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
                    if (this.props.value.match(validRegex)) {
                        //////console.log("TRUE")
                        // var tmp = this.props.value.split(".")
                        // if(tmp[1].length >3){
                        //     this.setState({errorCustom:true,helperText:"Please enter valid email", error: true})
                        // }
                        var tmp = this.props.value.split("@")
                        if (tmp.length === 2) {
                            // Split the domain part further at the '.'
                            var aftersplit = tmp[1].split(".");
                            if (aftersplit.length < 2 || aftersplit[1].length < 2) {
                                this.setState({errorCustom: true, helperText: "Please enter a valid email", error: true});
                            }
                        } else {
                            // If the email doesn't contain exactly one "@", it's invalid
                            this.setState({errorCustom: true, helperText: "Please enter a valid email", error: true});
                        }
                    }
                    else if(this.props.value.length>0){
                        //////console.log("ERROR")
                        this.setState({errorCustom:true,helperText:"Please enter valid email", error: true})
                    }
                }
                else if(this.props.required && this.props.value === ''){
                    this.setState({errorCustom:true,helperText:"Field is required", error: true})
                } 
                if(this.props.onBlur){
                    //////console.log(this.props.onBlur)
                    this.props.onBlur(this.props)
                }

                //////console.log("TAB ::::: ", this.props)
            }}
        />}
         
        {this.props.autoFocus !== true &&<TextField  
            defaultValue='asdasd '
            label={this.props.label}
            name ={this.props.name}
            id={this.props.name}
            error={this.state.error}
            helperText={this.state.helperText} 
            type={this.props.type}
            value={this.props.value||''}
            disabled={this.props.disabled}
            required={this.props.required}
            fullWidth={this.props.fullWidth}
            onFocus={()=>{
                console.log("LP SETTINGS FOCUSSED")
            }}
            InputProps={{
                autoComplete: 'off',
                ...this.props.InputProps
            }}
            onChange={(e)=>{
                //console.log(this.props.format); 
                
                if(e.target.value.length >= (Number(this.props.maxLength))){
                    e.target.value = e.target.value.substring(0, this.props.maxLength)
                }
                this.props.onChange(e)
            }}
            style={this.props.style}
            placeholder={this.props.label}
            tabindex={this.props.tabindex}
            onKeyDown={(e)=>{ 
                ////console.log(e)
                if(this.props.maxLength !== undefined && Number(this.props.maxLength) > 0 && this.props.format === 'text'){
                    if(e.keyCode !== 8 && e.keyCode !== 9 && e.keyCode !== 37 && e.keyCode !== 39 && e.keyCode !== 46 && e.target.value.length >= (Number(this.props.maxLength)+1) && e.key !== 'Ctrl' && e.key !== 'Shift'){
                        e.preventDefault();
                    }
                }
                
                if((this.props.format === 'number' ) && e.key!=='Tab' && e.keyCode !== 8 && e.keyCode !== 46){
                    const pattern = /^[0-9]$/;  
                    // //console.log("NUMBER FORMAT")
                    // //console.log(e)
                    if(!pattern.test(e.key)){
                        e.preventDefault();
                    } 
                }
                else if((this.props.format === 'numberdecimal' || this.props.format === 'currency') && e.target.value.toString().indexOf('.') === -1 && e.keyCode !== 8 && e.keyCode !== 9 && e.keyCode !== 46 ){
                    const pattern = /^[0-9.]$/; 
                    //console.log(e)
                    //console.log(pattern.test(e.key))
                    if(!pattern.test(e.key) && e.keyCode !== 9 && e.keyCode !== 37 && e.keyCode !== 39){
                        e.preventDefault();
                    }
                }
                else if((this.props.format === 'numberdecimal' || this.props.format === 'currency') && e.target.value.toString().indexOf('.') !== -1 && e.keyCode !== 8 && e.keyCode !== 9 && e.keyCode !== 46 ){
                    // const pattern =; 
                    //////console.log(e)
                    if(! /^[0-9]$/.test(e.key) && e.keyCode !== 9 && e.keyCode !== 37 && e.keyCode !== 39){
                        e.preventDefault();
                    }
                }

                else if(this.props.format === 'percentage' && e.target.value.toString().indexOf('.') === -1 && e.keyCode !== 8 && e.keyCode !== 9 && e.keyCode !== 46 ){
                    const pattern = /^[0-9.]$/; 
                    //////console.log(e)
                    if(!pattern.test(e.key) && e.keyCode !== 9 && e.keyCode !== 37 && e.keyCode !== 39){
                        e.preventDefault();
                    }
                    let temp = (e.target.value+e.key).toString().split(".") 
                    let chkval = temp.length > 1 ? temp[1].length  : 2
                    if(Number((e.target.value+e.key)) === 100 && e.key === '.'){
                        e.preventDefault()
                    }
                    if(Number((e.target.value+e.key)) > 100 || chkval > 2){
                        e.preventDefault()
                    }
                }
                else if(this.props.format === 'percentage' && e.target.value.toString().indexOf('.') !== -1 && e.keyCode !== 8 && e.keyCode !== 9 && e.keyCode !== 46 ){
                    // const pattern =; 
                    //////console.log(e)
                    if(! /^[0-9]$/.test(e.key) && e.keyCode !== 9 && e.keyCode !== 37 && e.keyCode !== 39){
                        e.preventDefault();
                    }
                    let temp = (e.target.value+e.key).toString().split(".") 
                    let chkval = temp.length > 1 ? temp[1].length  : 2
                    if(Number((e.target.value+e.key)) === 100 && e.key === '.'){
                        e.preventDefault()
                    }
                    if(Number((e.target.value+e.key)) > 100 || chkval > 2){
                        e.preventDefault()
                    }
                }


                else if(this.props.format==='text' || this.props.format==='string'){
                    var k ;
                    document.all ? k = e.keyCode : k = e.which;
                    ////console.log(k)
                    // var iChars = "!@#$%^&*()+=-[]\\\';,./{}|\":<>?";
                    // if(((k > 64 && k < 91) || (k > 96 && k < 123)|| k===39 || k===37 || k ===9  || k === 8 || k === 32)){
                    //     ////console.log("IF")
                    //     if(iChars.indexOf(e.))
                    // }
                    // else{
                    //     ////console.log("ELSE")
                    //     e.preventDefault();
                    // }

                    let key = e.key;
                    let keyCharCode = key.charCodeAt(0);
//console.log(keyCharCode)
                    const pattern = /^[a-zA-Z0-9]*$/ 
                    // 0-9
                    if(keyCharCode >= 48 && keyCharCode <= 57) {
                        return key;
                    }
                    // A-Z
                    else if(keyCharCode >= 65 && keyCharCode <= 90) {
                        return key;
                    }
                    // a-z
                    else if(keyCharCode >= 97 && keyCharCode <= 122) {
                        return key;
                    }
                    // space , - 
                    else if(keyCharCode === 32 || keyCharCode === 44 ||keyCharCode === 45) {
                        return key;
                    }
                    else if(pattern.test(e.key)){//
                        e.preventDefault();
                    }
                    else{
                        ////console.log("ELSE")
                        e.preventDefault();
                    }
                } 
                else if(this.props.format === 'email'){
                    var m;
                     document.all ? m = e.keyCode : m = e.which;  
                     const pattern = /^[a-zA-Z0-9_@.-]*$/
                     if(pattern.test(e.key)){//((m > 64 && m < 91) || (m > 96 && m < 123) || m===39 || m===37 || m===9 || m === 8 || m === 32 || m === 50 || m === 190)){
                        ////console.log("IF")
                        // var tmp = this.props.value.split(".")
                        // if(tmp[1].length >= 3 && e.keyCode !== 8 && e.keyCode !== 9 && e.keyCode !== 46){
                        //     e.preventDefault()
                        // }
                    }
                    else{
                        ////console.log("ELSE")
                        e.preventDefault();
                    }
                } 
            }}
            onBlur={()=>{

                console.log("LP SETTINGS onblur called", this.props.label)
                this.setState({error:false, helperText:'',errorCustom:false}) 
                if(this.props.format === 'email'){
                    var validRegex =  /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/; ///^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
                    if (this.props.value.match(validRegex)) {
                        //////console.log("TRUE")
                        // var tmp = this.props.value.split(".")
                        // if(tmp[1].length >3){
                        //     this.setState({errorCustom:true,helperText:"Please enter valid email", error: true})
                        // }
                        var tmp = this.props.value.split("@")
                        if (tmp.length === 2) {
                            // Split the domain part further at the '.'
                            var aftersplit = tmp[1].split(".");
                            if (aftersplit.length < 2 || aftersplit[1].length < 2) {
                                this.setState({errorCustom: true, helperText: "Please enter a valid email", error: true});
                            }
                        } else {
                            // If the email doesn't contain exactly one "@", it's invalid
                            this.setState({errorCustom: true, helperText: "Please enter a valid email", error: true});
                        }
                    }
                    else if(this.props.value.length>0){
                        //////console.log("ERROR")
                        this.setState({errorCustom:true,helperText:"Please enter valid email", error: true})
                    }
                }
                else if(this.props.required && this.props.value === ''){
                    this.setState({errorCustom:true,helperText:"Field is required", error: true})
                } 
                if(this.props.onBlur){
                    //////console.log(this.props.onBlur)
                    this.props.onBlur(this.props)
                }

                //////console.log("TAB ::::: ", this.props)
            }}
        />}
         </>
    }
}

FTextField.propTypes = {
    label: PropTypes.string,
    name: PropTypes.string,
    id: PropTypes.string,
    error: PropTypes.bool,
    disabled:PropTypes.bool,
    helperText: PropTypes.string,
    type: PropTypes.string,
    value: PropTypes.string,
    required: PropTypes.bool,
    color: PropTypes.oneOf([
      'default',
      'primary',
      'secondary',
      'info',
      'success',
      'warning',
      'error'
    ]),
    fullWidth: PropTypes.bool,
    inputProps: PropTypes.object,
    onChange: PropTypes.func,
    onKeypress:PropTypes.func,
    onBlur:PropTypes.func,
    InputProps: PropTypes.object,
    style: PropTypes.object,
    defaultValue: PropTypes.number,
    rows: PropTypes.object,
    multiline:PropTypes.bool,
    minLength: PropTypes.number,
    maxLength: PropTypes.number,
    format: PropTypes.string,
    tabindex: PropTypes.number
  };
